module.exports = __webpack_public_path__ + "untitled-serif-700.462031da8da58b8b08614d68614c5689.woff";